import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  CuiLink,
  CuiPagination,
  CuiSideBar,
  CuiSideBarButton,
} from '../../components';

import { breakpoints, keyCodes } from '../../../services';

export class AppChrome extends Component {
  componentDidMount() {
    const { isMinimizedView, setMinimizedView, closeSideBar } = this.props;

    const updateMinimizedState = () => {
      if (window.innerWidth <= breakpoints.hideNavigationBreakpoint) {
        // Only if we've just become minimized do we want to close
        // the sideBar.
        if (isMinimizedView === false || isMinimizedView === null) {
          setMinimizedView(true);
          closeSideBar();
        }
      } else if (isMinimizedView === true || isMinimizedView === null) {
        // Update minimized state if the window has expanded to be unminimized.
        setMinimizedView(false);
      }
    };

    if (window) {
      updateMinimizedState();

      window.addEventListener('resize', () => {
        updateMinimizedState();
      });
    }

    document.addEventListener('keydown', e => {
      if (e.target !== document.body) {
        return;
      }

      let newPage;

      switch (e.keyCode) {
        case keyCodes.LEFT:
          newPage = this.props.page.previousPage;
          break;
        case keyCodes.RIGHT:
          newPage = this.props.page.nextPage;
          break;
        default:
          break;
      }

      if (newPage) {
        this.props.goToRoute(newPage.id);
      }
    });
  }

  renderPagination = currentPage => (
    <CuiPagination
      toNext={
        currentPage.nextPage ? { type: currentPage.nextPage.id } : undefined
      }
      toPrevious={
        currentPage.previousPage
          ? { type: currentPage.previousPage.id }
          : undefined
      }
    />
  );

  render() {
    const {
      isSideBarOpen,
      pages,
      openSideBar,
      closeSideBar,
      page: { name: pageName, component: PageComponent },
    } = this.props;

    if (isSideBarOpen) {
      document.body.classList.add('is-sideBar-open');
    } else {
      document.body.classList.remove('is-sideBar-open');
    }

    return (
      <div>
        <CuiSideBar
          isOpen={isSideBarOpen}
          routes={pages}
          onClose={closeSideBar}
          title="Flexbox Patterns"
          homePath={{ type: 'HOME' }}
          author={
            <CuiLink href="http://www.cenizal.com">by CJ Cenizal</CuiLink>
          }
        />

        <CuiSideBarButton
          showClose={isSideBarOpen}
          onOpen={openSideBar}
          onClose={closeSideBar}
        />

        <div className="app">
          <PageComponent name={pageName} />
          {this.renderPagination(this.props.page)}
        </div>
      </div>
    );
  }
}

AppChrome.propTypes = {
  isSideBarOpen: PropTypes.bool,
  openSideBar: PropTypes.func.isRequired,
  closeSideBar: PropTypes.func.isRequired,
  pages: PropTypes.array.isRequired,
  goToRoute: PropTypes.func.isRequired,
  isMinimizedView: PropTypes.bool,
  setMinimizedView: PropTypes.func.isRequired,
  page: PropTypes.shape({
    name: PropTypes.string,
    path: PropTypes.string,
    previousPage: PropTypes.object,
    nextPage: PropTypes.object,
    component: PropTypes.func.isRequired,
  }).isRequired,
};

AppChrome.defaultProps = {
  isSideBarOpen: false,
  isMinimizedView: false,
};



// WEBPACK FOOTER //
// ./ui/views/app/AppChrome.js